import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class surveyReviewsTableRowCtrl implements IController {

  surveyReviewsTableCtrl: any;
  review: any;
  questions: any;

  private questionsByType: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (this.review && _.get(this.questions, 'length')) {
      this.questionsByType = _.map(this.questions, (q) => {
        return _.find(this.review.questions, (reviewQuestion) => {
          return q.question === reviewQuestion.question;
        })
      })
    }
  }

  $onChanges(changes) {
    if (changes.review && !changes.review.isFirstChange()) {
      this.$onInit();
    }
    if (changes.questions && !changes.questions.isFirstChange()) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.survey')
  .component('surveyReviewsTableRow', {
    require: {
      surveyReviewsTableCtrl: '^surveyReviewsTable'
    },
    bindings: {
      review: '<',
      questions: '<'
    },
    template: require('./survey-reviews-table-row.html').default,
    controller: surveyReviewsTableRowCtrl
  });
